import axios from 'axios';

export function getSupportedLocales() {
  return axios.get('/api/available-locales');
}

export async function supportedLocalesInclude(locale) {
  getSupportedLocales().then(({ data }) => data.find((lang) => lang.code === locale));
}
